import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import DownloadIcon from "@mui/icons-material/SaveAltRounded";
import { IconButton, Stack, Tooltip } from "@mui/material";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import { useFilesContext } from "../FilesContext";
import type { FilesRowModel } from "../filesState";
import { removeUploadingFileAction } from "../filesState";

interface Props {
  row: FilesRowModel;
}

const StoredFileActionsCell = ({ row }: Props) => {
  const { onDownloadFile, onDeleteFile, hasPermissionsToManage } = useFilesContext();

  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
      <Tooltip title="Download" arrow>
        <IconButton onClick={() => onDownloadFile(row)}>
          <DownloadIcon />
        </IconButton>
      </Tooltip>
      <ActionsMenuButton
        items={[
          {
            disabled: !hasPermissionsToManage,
            label: "Delete",
            icon: <DeleteIcon color="error" />,
            onClick: () => onDeleteFile(row),
          },
        ]}
      />
    </Stack>
  );
};

const InvalidFileActionsCell = ({ catalogueId }: { catalogueId: string }) => {
  const { setFilesState } = useFilesContext();

  const handleRemove = () => {
    setFilesState(removeUploadingFileAction(catalogueId));
  };

  return (
    <Tooltip title="Remove" arrow>
      <IconButton color="error" onClick={handleRemove}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
};

const FilesGridActionsCell = ({ row }: Props) => {
  if (row.uploadState === undefined) {
    return <StoredFileActionsCell row={row} />;
  }

  if (row.uploadState.status !== "error") {
    return null;
  }

  return <InvalidFileActionsCell catalogueId={row.catalogueId} />;
};

export default FilesGridActionsCell;
